import { zodResolver as createZodResolver } from '@hookform/resolvers/zod';
import type { FieldValues, Resolver } from 'react-hook-form';
import type { ZodType } from 'zod';

/**
 * Zod 4 distinguishes raw field input from parsed output (coercion, defaults).
 * Forms keep using the parsed value type; the resolver still validates the raw input.
 */
export function zodResolver<T extends FieldValues>(schema: ZodType<T, FieldValues>): Resolver<T> {
  return createZodResolver(schema as never) as Resolver<T>;
}
